import { isStandalone } from '@/utils/platform/isStandalone';

import useNormalAuth from './useNormalAuth';
import useStandAloneAuth from './useStandaloneAuth';

const useAuth = () => {
  const {
    isResolved: isStandAloneAuthResolved,
    isAuthorized: isStandAloneAuthorized,
  } = useStandAloneAuth();

  const { isAuthorized: isNormalAuthorized } = useNormalAuth();

  const isStandAloneApp = isStandalone();

  return {
    isResolved: isStandAloneApp ? isStandAloneAuthResolved : true,
    isAuthorized: isStandAloneApp ? isStandAloneAuthorized : isNormalAuthorized,
  };
};

export default useAuth;
